import "./firebase/firebaseConfig"; // Import firebaseConfig to initialize Firebase
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Shared game chrome (.final-results-*, .home-button, .drag-quiz-logo).
// Imported ONCE, here, so there is exactly one owner of those class names.
// See the header of styles/game-shell.css for why that matters.
import './styles/game-shell.css';
import App from './App';
import { installCloudVoice } from './services/cloudVoice';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

// every game's read-aloud uses the realistic cloud voice (falls back to the
// device voice) — services/cloudVoice.js
installCloudVoice();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
